const API_URL = import.meta.env.PROD
  ? 'https://teammanager-api.rocketworks.workers.dev' // worker URL
  : 'http://localhost:8787' // for local development

// Fetch full team
export async function getTeam() {
  const res = await fetch(API_URL)
  if (!res.ok) throw new Error(`Failed to fetch team: ${res.statusText}`)
  return res.json()
}

// Add new member
export async function addTeamMember(member) {
  const res = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(member)
  })
  if (!res.ok) throw new Error(`Failed to add member: ${res.statusText}`)
  return res.json() // returns full updated team
}

// Update existing member
export async function updateTeamMember(member) {
  if (!member.id) throw new Error('Missing ID for update')
  const res = await fetch(API_URL, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(member)
  })
  if (!res.ok) throw new Error(`Failed to update member: ${res.statusText}`)
  return res.json() // returns full updated team
}

// Delete member
export async function deleteTeamMember(id) {
  if (!id) throw new Error('Missing ID for delete')
  const res = await fetch(API_URL, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id })
  })
  if (!res.ok) throw new Error(`Failed to delete member: ${res.statusText}`)
  return res.json() // returns full updated team
}
